/**
 * Customisation Judge.me
 */

window.addEventListener('load', function() {
  // Attendre que Judge.me soit complètement chargé
  setTimeout(function() {
    const widget = document.querySelector('#judgeme_product_reviews');
    if (!widget) return;

    // 1. Enlever "sur 5" du summary average
    const summaryAverage = widget.querySelector('.jdgm-rev-widg__summary-average');
    if (summaryAverage) {
      let text = summaryAverage.textContent;
      text = text.replace(/\s*sur\s*5/gi, '');
      text = text.replace(/\s*\/\s*5/g, '');
      summaryAverage.textContent = text.trim();
    }

    // 2. Wrapper toutes les .jdgm-star dans un container spécifique
    const summaryStars = widget.querySelector('.jdgm-rev-widg__summary-stars');
    if (summaryStars) {
      // Chercher toutes les étoiles individuelles
      const stars = summaryStars.querySelectorAll('.jdgm-star');

      if (stars.length > 0 && !stars[0].parentElement.classList.contains('jdgm-stars-container')) {
        // Créer le container pour les étoiles
        const starsContainer = document.createElement('div');
        starsContainer.className = 'jdgm-stars-container';

        // Insérer le container avant la première étoile
        stars[0].parentNode.insertBefore(starsContainer, stars[0]);

        // Déplacer toutes les étoiles dans le container
        stars.forEach(function(star) {
          starsContainer.appendChild(star);
        });
      }
    }

    // 3. Déplacer jdgm-rev-widg__summary-text dans jdgm-rev-widg__summary-stars
    const summaryText = widget.querySelector('.jdgm-rev-widg__summary-text');
    if (summaryText && summaryStars && !summaryStars.contains(summaryText)) {
      summaryStars.appendChild(summaryText);
    }

    // 4. Créer un container global pour jdgm-stars-container + jdgm-rev-widg__summary-text
    const starsContainer = summaryStars.querySelector('.jdgm-stars-container');
    const summaryTextInStars = summaryStars.querySelector('.jdgm-rev-widg__summary-text');

    if (starsContainer && summaryTextInStars && !starsContainer.parentElement.classList.contains('jdgm-stars-and-text-wrapper')) {
      // Créer le wrapper global
      const wrapper = document.createElement('div');
      wrapper.className = 'jdgm-stars-and-text-wrapper';

      // Insérer le wrapper avant le container des étoiles
      starsContainer.parentNode.insertBefore(wrapper, starsContainer);

      // Déplacer les deux éléments dans le wrapper
      wrapper.appendChild(starsContainer);
      wrapper.appendChild(summaryTextInStars);
    }
  }, 2000);
});
